module.exports = __webpack_public_path__ + "img/FotoMo11.3703eea0.png";